/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_In_Reason_From_Order_CancelInputs */

const vi_pkl_in_reason_from_order_cancel = /** @type {(inputs: Pkl_In_Reason_From_Order_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn từ hủy đơn`)
};

/**

* @param {Pkl_In_Reason_From_Order_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_in_reason_from_order_cancel = /** @type {((inputs?: Pkl_In_Reason_From_Order_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_In_Reason_From_Order_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_in_reason_from_order_cancel(inputs)
});